import { render, staticRenderFns } from "./UPortlet.vue?vue&type=template&id=3c558c27&"
import script from "./UPortlet.vue?vue&type=script&lang=js&"
export * from "./UPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports